import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTextSize = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M7 4V20M5 20H9M11 7V4H3V7M18 4V20M18 4L15 7M18 4L21 7M18 20L15 17M18 20L21 17",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgTextSize;
